import './_breadcrumb.scss';

/*
 * Init Breadcrumb component
 */
export default function Breadcrumb() {
    const $breadcrumb = document.querySelector('#main-wrapper .region-breadcrumb .block-text a') as HTMLDivElement;

    $breadcrumb &&
        $breadcrumb.addEventListener('click', () => {
            if (document.referrer) {
                window.location.href = document.referrer;
            } else {
                history.back();
            }
        });
}
